import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

import * as Feather from 'feather-icons';
import * as marked from 'marked';

import {
  CapitanDocumentElementTypes,
  CapitanGenericDocumentElementTypes,
  ClimberInfoRequiredDocumentElementTypes,
  DocumentElementType,
  DocumentTemplateElement,
  getDocumentElementTypeDisplay
} from '../../../../../../../../models/document-template';
import { DomSanitizer } from '@angular/platform-browser';
import { OrganizationConfig } from '../../../../../../../../models/organization-config';
import { CountryCodes, CountryIsoCodes, StateCodes } from '../../../../../../../../utils';
import { CustomCustomerFieldType } from '../../../../../../../../models/organization-config-enums';
import { MarkdownRenderService } from '../../../../../../../../services/markdown-render/markdown-render.service';

@Component({
  selector: 'app-document-template-element',
  templateUrl: './document-template-element.component.html',
  styleUrls: ['./document-template-element.component.css']
})
export class DocumentTemplateElementComponent implements OnInit {

  constructor(
    public markdownRenderService: MarkdownRenderService,
    private domSanitizer: DomSanitizer,
  ) {}

  // Element is an input only, not an output, because the element's contents
  // will be modified, but a new element will not be emitted.
  @Input()
  element: DocumentTemplateElement;

  @Input()
  canMoveUp: boolean;

  @Input()
  canMoveDown: boolean;

  @Input()
  canRemove: boolean;

  @Input()
  orgConfig: OrganizationConfig;

  @Output()
  moveUp: EventEmitter<void> = new EventEmitter<void>();

  @Output()
  moveDown: EventEmitter<void> = new EventEmitter<void>();

  @Output()
  remove: EventEmitter<void> = new EventEmitter<void>();

  @Output()
  unsavedChanges: EventEmitter<void> = new EventEmitter<void>();

  elementId = Math.random().toString(36).replace(/[^a-z]+/g, '').substr(0, 5);

  // Create instance references to lookup functions and enums so they may be
  // called in the template.
  public getDocumentElementTypeDisplay = getDocumentElementTypeDisplay;
  public DocumentElementType = DocumentElementType;
  public CapitanDocumentElementTypes = CapitanDocumentElementTypes;
  public CapitanGenericDocumentElementTypes = CapitanGenericDocumentElementTypes;
  public ClimberInfoRequiredDocumentElementTypes = ClimberInfoRequiredDocumentElementTypes;
  public CustomCustomerFieldType = CustomCustomerFieldType;

  public readonly StateCodes = StateCodes[CountryIsoCodes.UNITED_STATES];
  public readonly CountryCodes = CountryCodes;

  ngOnInit() {
    if (this.element.editing) {
      this.enterEditMode();
    }

    Feather.replace();
  }

  public enterEditMode() {
    this.element.editing = true;
  }

  public exitEditMode() {
    this.element.editing = false;
  }

  public getVideoEmbedCode() {
    return this.domSanitizer.bypassSecurityTrustHtml(
      this.element.parameters.video_embed_code
    );
  }

  public questionChoiceTrackByFn(index, item) {
    return index;
  }
}
